import { getLanguageCode } from '../utilities';

export default class InvoiceUnpaidClient
{
    constructor()
    {
        let languageCode = getLanguageCode();
        this._uri = '/v1-api-unpaid-invoice-details-' + languageCode;
        this._dataSrc = 'response';
    }

    get uri()
    {
        return this._uri;
    }

    get dataSrc()
    {
        return this._dataSrc;
    }
    /**
	 * GET
	 */

    /**
	 * @returns {Promise<Response>}
	 */
    fetchAllItems()
    {
        return fetch(this._uri);
    }
}
